import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';
import ProductCard from '@/components/feature/ProductCard';

export default function FeaturedProducts() {
  const featured = products.slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热销黄油推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              精选全球优质黄油，品质保障，价格透明
            </p>
          </div>
          <Link
            to="/categories"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((product) => (
            <ProductCard key={product.id} {...product} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/categories"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 border border-primary-300 text-primary-500 rounded-md text-sm font-medium hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部商品
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}